export default "__VITE_ASSET__lbs4$D3Q__"